export default "__VITE_ASSET__BpM3tMlr__"